import { auroraBaseColors, auroraDarkThemeColors, auroraLightThemeColors } from './auroraColors'
import { baseColors, ThemeColors } from './colors'

/**
 * Lyra Connect color overrides extending Aurora theme.
 * Only overrides specific tokens that differ from Aurora.
 */
export const connectLightThemeColors: ThemeColors = {
  ...auroraLightThemeColors,

  // Background - Connect uses white background for sidebar/primary areas
  backgroundPrimary: baseColors.white,
  // backgroundSecondary keeps Aurora's blue-tinted background for pages like Resources
  backgroundSecondary: auroraBaseColors.cobalt_20,
  // backgroundElement - neutral gray for cards on blue backgrounds
  backgroundElement: baseColors.oatmeal_15,

  // Border - Override for visibility on white backgrounds
  borderDefault: baseColors.oatmeal_30,
  borderInput: baseColors.teal_40,

  // Gradient colors for header sections (article pages, etc.)
  backgroundGradientFirst: auroraBaseColors.cobalt_20,
  backgroundGradientSecond: auroraBaseColors.gradient_background_blend,

  // Logo - Connect uses dark navy logo
  icons: {
    ...auroraLightThemeColors.icons,
    lyraLogoPrimaryIcon: {
      fill: auroraBaseColors.cobalt_75,
    },
  },
}

export const connectDarkThemeColors: ThemeColors = {
  ...auroraDarkThemeColors, // TBD
}
